import { ISection } from "../../models/section";
import { ICategory } from "../../models/category";
export const transformFromSectionToCSV = (
  section: ISection,
  categories: ICategory[],
) => {
  // カテゴリIDをキーとするマップを作成
  const categoryMap = new Map<number, string>();
  categories.forEach((category) => {
    categoryMap.set(category.id, category.name);
  });

  // 各セクションに対応するカテゴリ名を追加
  const categoryName = categoryMap.get(section.category_id) || "Unknown";
  return {
    id: section.id,
    name: section.name,
    description: section.description,
    category_id: section.category_id,
    category_name: categoryName,
  };
};
